"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const RadioCheckedIcon_1 = __importDefault(require("./RadioCheckedIcon"));
const NoAnimationRadio = (props) => {
    return react_1.default.createElement(core_1.Radio, Object.assign({ checkedIcon: react_1.default.createElement(RadioCheckedIcon_1.default, null) }, props));
};
exports.default = NoAnimationRadio;
//# sourceMappingURL=NoAnimationRadio.js.map